<h2 mat-dialog-title>Buscar e Cadastrar Administrador</h2>

<mat-dialog-content>
  <div class="aviso-responsabilidade">
    <mat-icon>info</mat-icon>
    <span>Você é responsável pelos acessos concedidos. Acompanhe esses acessos e remova administradores em caso de desligamento da unidade.</span>
  </div>

  <div style="display: flex; gap: 10px; align-items: baseline; margin-bottom: 16px">
    <mat-form-field appearance="outline" style="flex: 1">
      <mat-label>Username UNICAMP</mat-label>
      <input matInput [formControl]="usernameFC" (keyup.enter)="buscar()" aria-label="Username do usuário a buscar" />
      <span matSuffix class="mat-suffix-custom">&commat;unicamp.br</span>
    </mat-form-field>
    <button mat-raised-button color="primary" style="height: 56px; margin-bottom: 20px" (click)="buscar()" [disabled]="buscando || !usernameFC.valid">
      <mat-icon>search</mat-icon> Buscar
    </button>
  </div>

  <div *ngIf="buscando" fxLayoutAlign="center center" style="padding: 20px">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <div *ngIf="usuario && !buscando" class="resultado-busca">
    <h3>Resultado da busca</h3>

    <div class="dados-usuario">
      <div class="campo"><strong>Nome:</strong> {{ usuario.nome }}</div>
      <div class="campo"><strong>Username:</strong> {{ usuario.username }}</div>
      <div class="campo"><strong>E-mail:</strong> {{ usuario.email }}</div>
      <div class="campo"><strong>Matrícula:</strong> {{ usuario.matricula || 'Não informada' }}</div>
      <div class="campo"><strong>Unidade:</strong> {{ usuario.unidade || 'Não informada' }}</div>
      <div class="campo"><strong>Código Unidade:</strong> {{ usuario.codigoUnidade || 'Não informado' }}</div>
      <div class="campo">
        <strong>Tipo:</strong>
        <span *ngIf="usuario.isDocente" class="chip-docente">Docente</span>
        <span *ngIf="!usuario.isDocente" class="chip-staff">Funcionário</span>
      </div>
    </div>

    <div *ngIf="!podeCadastrar()" class="alerta-bloqueio">
      <mat-icon>warning</mat-icon>
      <span>{{ getMotivoBloqueioCadastro() }}</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close [disabled]="cadastrando">Cancelar</button>
  <button mat-raised-button color="primary" (click)="cadastrar()" [disabled]="!podeCadastrar() || cadastrando" *ngIf="usuario && !buscando">
    <mat-icon *ngIf="cadastrando" class="spin">sync</mat-icon>
    Cadastrar como Administrador
  </button>
</mat-dialog-actions>
